import Cookies from 'js-cookie';
export default class CyberCookies {
    static mount() {
        new CyberCookies();
    }
    constructor() {
    }
    static isContrastEnabled() {
        return Cookies.get('contrast') === 'true';
    }
    static setContrastEnabled(enabled) {
        Cookies.set('contrast', enabled.toString());
    }
}
